import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { selectCurrentDocumentPreview, selectIsCurrentDocumentPreviewLoading } from '@lib/medical-documents/core/store/medical-documents.selectors';

import { LoaderComponent } from '@lib/shared-ui/layout/loader/loader.component';

@Component({
  selector: 'md-document-preview',
  standalone: true,
  imports: [NgOptimizedImage, LoaderComponent, TranslatePipe],
  template: `
    <div class="flex h-full w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-neutral-300 p-4">
      @if (!isLoading()) {
        @if (!previewUrl()) {
          <div class="flex max-w-[50%] flex-col items-center gap-2">
            <img priority="true" alt="Document Icon" width="100" height="100" [ngSrc]="'assets/images/document-placeholder.svg'" />
            <h4>{{ 'medicalDocuments.labels.preview' | translate }}</h4>
            <span class="max-w-[360px] text-center text-sm text-gray-2">{{ 'medicalDocuments.labels.startPreview' | translate }}</span>
          </div>
        } @else {
          <iframe class="border-none" [src]="previewUrl()" [width]="'100%'" [height]="'100%'"></iframe>
        }
      } @else {
        <shared-loader></shared-loader>
      }
    </div>
  `,
  styles: `
    :host {
      height: 100%;
      width: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPreviewComponent {
  protected readonly store = inject(Store);

  protected readonly previewUrl = this.store.selectSignal(selectCurrentDocumentPreview);
  protected readonly isLoading = this.store.selectSignal<boolean>(selectIsCurrentDocumentPreviewLoading);
}
